import Vue from 'vue'

Vue.filter('trans', function (obj) {
  if (obj && obj.fr) {
    return obj.fr
  } else if (typeof obj === 'string') {
    return obj
  } else {
    return ''
  }
})



// WEBPACK FOOTER //
// ./src/filters/lang.js